<!-- 录退件码 -->
<template>
<el-form label-width="120px">
    <el-row>
        <el-col :xs="24" :sm="20">
            <el-form-item :label="msg('订单编号')">
                <el-input v-model="code" size="small" disabled>
                </el-input>
            </el-form-item>
            <el-form-item :label="msg('退件码')">
                <el-input v-model.trim="returnCode" ref="expCodeRef" placeholder="请输入退件码" size="small">
                </el-input>
            </el-form-item>
        </el-col>
    </el-row>
  
    <div style="text-align:center;">
        <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
        <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('取消')}}</el-button>
    </div>

</el-form> 
</template>

<script>
export default {
  name: 'ExpCodeInput',
  data(){
    return{
        id:null,
        code:null,
        returnCode:null,
    }
    
  }, 
  props: {
    },
  computed:{
  },
  mounted: function(){
  },
  methods:{
    init(id,code){
        this.id = id;
        this.code = code,
        this.returnCode = null
    },
    onSubmit(){
        if(!this.returnCode){
            this.$message(this.msg('请录入退件码'));
            return;
        }
        if(!/^[a-zA-Z0-9]+$/.test(this.returnCode) || this.returnCode.length <= 6){
            this.$message(this.msg('参数不合法，退件码录入失败'));
            return;
        }
        this.$axios.get(this.$kit.api.stock.updateRetrunCode+"?s="+this.id+"&r="+this.returnCode,)
            .then((result) =>{
                this.$message(result.msg);
                if(result.status){
                   this.$emit("close-dg", true);
                }
               
            });
    },
  }
}
</script>

<style class="scss" scoped>


</style>
